import { Entity } from '@backstage/catalog-model';

/**
 * Parses the `cedarwell.tech/repo` annotation (e.g. "cedarwell/greater_heights")
 * into its owner/repo parts, as used by the Forgejo API.
 */
export function parseRepo(
  entity: Entity,
): { owner: string; repo: string } | undefined {
  const v = entity.metadata.annotations?.['cedarwell.tech/repo'];
  if (!v || !v.includes('/')) return undefined;
  const [owner, repo] = v.split('/', 2);
  return { owner, repo };
}

export const hasRepo = (entity: Entity): boolean => Boolean(parseRepo(entity));

/**
 * Formats an ISO timestamp as a short relative time string (e.g. "3h ago"),
 * shared by the delivery cards for commit/build/deploy timestamps.
 */
export function formatRelativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return iso;

  const diffSeconds = Math.round((Date.now() - then) / 1000);
  const abs = Math.abs(diffSeconds);
  const suffix = diffSeconds >= 0 ? 'ago' : 'from now';

  const units: Array<[string, number]> = [
    ['y', 365 * 24 * 60 * 60],
    ['mo', 30 * 24 * 60 * 60],
    ['d', 24 * 60 * 60],
    ['h', 60 * 60],
    ['m', 60],
  ];
  for (const [label, seconds] of units) {
    if (abs >= seconds) {
      return `${Math.floor(abs / seconds)}${label} ${suffix}`;
    }
  }
  return abs < 5 ? 'just now' : `${abs}s ${suffix}`;
}
